module.exports = __webpack_public_path__ + "img/KSC01616.20d6fd0b.jpg";